import { useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faTimes } from "@fortawesome/free-solid-svg-icons";

function UploadInput(props) {
  const [fileInfo, setFileInfo] = useState("");
  const fileInputRef = useRef(null); // <-- عشان نقدر نفرغ القيمة يدويًا

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileInfo(file.name);
    } else {
      setFileInfo("");
    }

    if (props.onChange) {
      props.onChange(event);
    }
  };

  const handleClearFile = () => {
    // 1. نفرغ الـ input
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }

    // 2. نفضي الستيت
    setFileInfo("");

    // 3. نبلغ الـ parent إن مفيش ملف
    if (props.onChange) {
      props.onChange({ target: { files: [] } });
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        ...props.parentStyle,
      }}
    >
      <Form.Label htmlFor={props.id} className="UploadInputLabel" style={{ cursor: "pointer" }}>
        <FontAwesomeIcon icon={faFile} />
      </Form.Label>

      <Form.Control
        type="file"
        id={props.id}
        style={{ display: "none" }}
        onChange={handleFileChange}
        ref={fileInputRef}
      />

      {!fileInfo ? (
        <span
          style={{
            marginTop: "10px",
            fontSize: "14px",
            color: "#6c757d",
          }}
        >
          {props.label}
        </span>
      ) : (
        <div
          style={{
            marginTop: "10px",
            fontSize: "14px",
            color: "var(--text-color)",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span>{fileInfo}</span>
          <button
            type="button"
            onClick={handleClearFile}
            style={{
              background: "transparent",
              border: "none",
              color: "red",
              cursor: "pointer",
              fontSize: "14px",
            }}
            title="إزالة الملف"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      )}
      {props.error && (
        <div className="error" style={{ marginTop: "5px", color: "red" }}>
          {props.error}
        </div>
      )}
    </div>
  );
}

export default UploadInput;
